Ext.define('SA.lq.edit.EditController', {
    constructor({model, cmps}) {
        this.model = model;
        this.cmps = cmps;
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations'])
            .selectTab('locations')
            .setModel(this.model)
            .apply();

        SA.Sidebar.setUseLocationHandler(locationStringId => this.onSidebarLocationSelect(locationStringId));

        SA.ProjectViewToolbar.clearToolbar();
        SA.ProjectView.show(this.cmps.projectView);

        this.refreshContent();
    },

    onRadioListLocationSelect(locationStringId) {
        this.selectLocation(locationStringId);
    },

    onSidebarLocationSelect(location) {
        var locationStringId = SA.data.LocationsCache.toLocationSeries(location);

        this.selectLocation(locationStringId);
        this.cmps.locationRadioList.scrollIntoViewRadioWithLocationStringId(locationStringId);
    },

    refreshContent() {
        var state = this.model.getState();

        this.cmps.header.setState(state);
        this.cmps.locationRadioList.setState(state);
    },

    selectLocation(locationStringId) {
        this.model.selectLocation(locationStringId);
        this.refreshContent();
    }
});